import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import GlobalSearch from '../../components/global-search';
import MainAppBar from '../../containers/main-appbar';
import MainContent from '../../containers/main-content';
import MainDrawer from '../../containers/main-drawer';
import { withDefaultStyles } from '../../utils/material-ui/hoc';
import Content from './containers/content';

class ConsoleMain extends React.Component<any, any> {
  public render() {
    return (
      <div style={this.props.style}>
        <MainAppBar title='Flybits Administrator Console'>
          <GlobalSearch style={{ width: '30%' }} />
        </MainAppBar>
        <MainDrawer selectedMenu='console'/>
        <MainContent>
          <Content />
        </MainContent>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(ConsoleMain)));



// WEBPACK FOOTER //
// ./src/sub-projects/console/main.tsx